export default __webpack_public_path__ + "static/media/adaya.a64b3aa7.png";